{
  "boostAvios": {
    "title": "Buustaa Avioksiasi",
    "body": "Moninkertaista <b>viime kuussa</b> keräämäsi Aviokset <b>jopa nelinkertaisiksi</b>. Kun buustaat, hinta on halvempi kuin Avioksia suoraan ostaessa. Voit buustata kerran kuussa. <a href=\"/fi-fi/finnair-plus/buy--transfer-or-exchange-avios/boost-your-avios\">Lue lisää Avioksien buustaamisesta.</a>",
    "boostNow": "Buustaa Avioksia",
    "eligibleHeading": "Tässä kuussa buustattavat Aviokset",
    "aviosLabel": "Aviosta",
    "mfaRequired": {
      "title": "Kaksivaiheinen tunnistautuminen vaaditaan",
      "text": "Voit ostaa tai siirtää Avioksia vasta, kun olet ottanut kaksivaiheisen tunnistautumisen käyttöön.",
      "enableNow": "Ota käyttöön nyt"
    },
    "mfaEnabled": {
      "title": "Kaksivaiheinen tunnistautuminen otettu käyttöön",
      "text": "Voit nyt palata buustaamaan Avioksiasi.",
      "manageAvios": "Hallinnoi Avioksia"
    },
    "eligibleTransactions": {
      "transactionsHeading": "Soveltuvat tilitapahtumat*",
      "aviosHeading": "Aviokset",
      "total": "Soveltuvia Avioksia viime kuussa:",
      "footnoteFinland": "*Sisältää lennetyt lennot sekä kumppaneidemme, kuten hotellien, autovuokraamojen ja Finnair Visan, kanssa tehdyt ostokset.",
      "loading": "Ladataan tilitapahtumia",
      "loadError": "Tilitapahtumien lataaminen epäonnistui. Päivitä sivu ja yritä uudelleen."
    },
    "aviosPending": {
      "title": "Etkö näe kaikkia viime kuussa keräämiäsi Avioksia?",
      "text": "Yleisimmät syyt löydät usein kysyttyjen kysymysten sivulta.",
      "readFaq": "Katso usein kysytyt kysymykset",
      "faqLink": {
        "url": "/fi-fi/frequently-asked-questions/finnair-plus/my-avios-from-last-month-aren-t-showing---why--4484334"
      }
    },
    "boostCompleted": {
      "title": "{amount} Aviosta lisätty",
      "text": "Avios-saldosi on nyt {to}."
    },
    "boostUnconfirmed": {
      "title": "Buustaustasi ei ole vielä vahvistettu",
      "text": "Tarkista Avios-saldosi myöhemmin uudelleen. Saat sähköpostiviestin, kun buustaus on vahvistettu tai jos maksu ei onnistunut."
    },
    "ineligible": {
      "alreadyBoosted": "Olet jo buustannut Avioksiasi tässä kuussa. Jatka keräämistä ja buustaa uudelleen ensi kuussa.",
      "belowMinimum": "Viime kuulta ei ole tarpeeksi Avioksia buustaamiseen. Tarvitset vähintään {minimum} Aviosta."
    },
    "promo": {
      "text": "Uutta: Buustaa viime kuussa keräämiäsi Avioksia niin saat palkintosi nopeammin.",
      "link": "Hallinnoi Avioksia"
    }
  },
  "navigation": {
    "newBadge": "Uusi"
  }
}
